import React from 'react';
import { useTheme } from '../../styles/ThemeProvider';
import { formatPct } from '../../utils/analytics/format';

export const ComparisonBadge = ({ delta, label = 'vs geçen ay', increaseIsBad = false }) => {
  const { theme } = useTheme();
  if (delta === null || delta === undefined || Number.isNaN(delta)) {
    return <span style={{ color: theme.color.muted, fontSize: theme.font.size.xs }}>—</span>;
  }
  const isPositive = delta >= 0;
  const isGood = increaseIsBad ? !isPositive : isPositive;
  const color = isGood ? theme.color.success : theme.color.danger;
  const arrow = isPositive ? '▲' : '▼';
  return (
    <span style={{
      color,
      fontSize: theme.font.size.xs,
      fontWeight: theme.font.weight.medium,
      display: 'inline-flex',
      gap: 4,
      alignItems: 'center',
    }}>
      <span>{arrow}</span>
      <span>{formatPct(Math.abs(delta))}</span>
      <span style={{ color: theme.color.muted, fontWeight: theme.font.weight.regular }}>{label}</span>
    </span>
  );
};
